module.exports = __webpack_public_path__ + "fe6dcf5a965035457af47825565772aa.pdf";